module.exports = __webpack_public_path__ + "static/media/apartment2.923f0730.jpg";